import { useAppSelector } from 'core/store';

export const useIsBrand = (brandName: string) => {
  const appVariablesData = useAppSelector((state) => state.appVariables.data);
  return appVariablesData?.brand === brandName;
};
